<template>
<div id="ServiceTypeAddEdit">
<b-modal id="modal-sm" size="md" title="Service Type Standard" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
  <div slot="default">
    <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
    <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
  </div> 
  <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
         <b-button variant="primary"  size="md"  class="float-right"  @click="PopMsgClose"> Close </b-button>
  </div>
</b-modal>  
<form>    

  <div class="form-group row my-0 mt-1">
    <label class="col-sm-4 label-small my-0">Service Type:</label>
    <div class="col-sm-8" v-if="selectService.length > 0">{{ serviceList }}</div>
  </div>  
  <div class="form-group row  my-0 mt-1">
    <label class="col-sm-4 label-small my-0">Service Sub Type:</label>
    <div class="col-sm-8" v-if="selectSubType.length > 0"> {{ subTypeList }} </div>
  </div>  
   
  <div class="form-group row  my-0 mt-1">
    <label class="col-sm-4  label-small my-0">STS Description:</label>
    <div class="col-sm-7 my-0">{{ newSTS.description }}      
    </div>
  </div>  

  <div class="form-group row my-0 mb-0 mt-1">
    <label class="col-sm-4 label-small mb-0">Effective Date:</label>
    <div class="col-sm-4 ">
      <datepicker typeable  :open-date="new Date()" v-model="effectiveDate" :format="DateFormat" 
      :bootstrap-styling="true" :input-class="datapickClass" :disabled="disableEffective||viewOnly" name="effectiveDatepicker"></datepicker>
    </div>       
  </div>
  <div class="form-group row my-0 py-0">
    <div class="col-sm-4 my-0 py-0">
    </div> 
    <p class="col-sm-8 my-0 py-0 sml-gray pl-3">Date Format: YYYY/MM/DD</p> 
  </div> 
  <div id="effErrors" :class="{'form-group row my-0 py-0': $v.effectiveDate.$error}" v-show="$v.effectiveDate.$error">
    <div class="col-sm-4 my-0 py-0" v-if="!$v.effectiveDate.required">   
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3" v-if="!$v.effectiveDate.required">Effective Date is required.</p> 
  </div>

  <div class="form-group row mmy-0 mb-0 mt-1">  
    <label class="col-sm-4 label-small my-0">Expiry Date:</label>
    <div class="col-sm-6  my-0 mb-0">
      <datepicker typeable :open-date="new Date()" v-model="expiryDate" :disabledDates="{ to: new Date(Date.now() - 8640000) }" :format="DateFormat" 
        :bootstrap-styling="true" :input-class="datapickClass" :disabled="disableExpiry||viewOnly" id="expDate" name="expirydatepicker"></datepicker>
    </div>    
    <div :class="'col-sm-4 mb-0'">
    </div>
  </div>
  <div class="form-group row my-0 py-0">
    <div class="col-sm-4 my-0 py-0">
    </div> 
    <p class="col-sm-8 my-0 py-0 sml-gray pl-3">Date Format: YYYY/MM/DD</p> 
  </div>   
  <div id="expErrors"  :class="{'form-group row my-0 py-0': $v.expiryDate.$error}" v-show="$v.expiryDate.$error">
    <div class="col-sm-4 my-0 py-0" v-if="!$v.effectiveDate.required">      
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3" v-if="!$v.effectiveDate.required">Expiry  Date is required.</p> 
    <div class="col-sm-4 my-0 py-0" v-if="!$v.expiryDate.minValue">      
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3" v-if="!$v.expiryDate.minValue">Expiry must be > effective date.</p> 
  </div>
     
  <div class="form-group row my-0 mt-1">
    <label class="col-sm-4 label-small my-0">Max Backdating Period:</label>
    <div class="col-sm-3 my-0 py-0 ">
         <select v-model="codeUnitMaxBack" class="form-control form-control-xs" :disabled="disableMaxBack||viewOnly" >
            <option disabled value="" selected="selected">Select Units</option>
            <option v-for="option in codeUnits" v-bind:value="option.abbrv" :key="option.abbrv">
              {{ option.description }}
            </option>
          </select>              
    </div>
    <div class="col-sm-2 my-0 py-0 ">
      <input id="maxBack" type="number" v-model="numMaxBack" placeholder="Length" 
        class="form-control form-control-xs" maxlength="3" :disabled="disableMaxBack||viewOnly" 
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        min="0" max="365"> 
    </div>
  </div> 
  <div class="form-group row my-0 mt-1">
      <div class="col-sm-4 label-small my-0">
      </div>
      <div class="col-sm-3">
        <label class="label-smaller-helper sml-gray">Units</label>
      </div>
      <div class="col-sm-3">
        <label class="label-smaller-helper">Length</label>
      </div>
  </div>
  <div id="bdErrors"  :class="{'form-group row my-0 py-0': $v.numMaxBack.$error}" v-show="$v.numMaxBack.$error">
    <div class="col-sm-4 my-0 py-0" v-if="!$v.numMaxBack.required">  
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3" v-if="!$v.numMaxBack.required">Backdating length required.</p> 
    <div class="col-sm-4 my-0 py-0" v-if="!$v.numMaxBack.between">  
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3" v-if="!$v.numMaxBack.between">Backdating length must be an integer between 0 and 365.</p> 
  </div>
   
  <div class="form-group row my-0 mt-1">
    <label class="col-sm-4 label-small my-0">Max Radiograph Count:</label>
    <div class="col-sm-5 my-0">
       <input id="maxGraph" type="number" v-model="numMaxGraphs" placeholder="Max Radiographics" 
          class="form-control form-control-xs" maxlength="3" :disabled="disableMaxGraph||viewOnly" 
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        min="0" max="999"> 
    </div>
  </div>
  <div id="MRErrors"  :class="{'form-group row my-0 py-0': $v.numMaxGraphs.$error}"  v-show="$v.numMaxGraphs.$error">
    <div class="col-sm-4 my-0 py-0" v-if="!$v.numMaxGraphs.required">      
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3"  v-if="!$v.numMaxGraphs.required">Radiographic count is required.</p> 
    <div class="col-sm-4 my-0 py-0" v-if="!$v.numMaxGraphs.between">      
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3" v-if="!$v.numMaxGraphs.between">Max radiographic must be an integer between 0 and 999.</p> 
  </div>

  <div class="form-group row my-0 mt-1">
    <label class="col-sm-4 label-small my-0">Max Cleaning:</label>
    <div class="col-sm-5 my-0">
       <input id="numMaxClean" type="number" v-model="numMaxClean" placeholder="Max Cleanings" 
          class="form-control form-control-xs" maxlength="3" :disabled="disableMaxClean||viewOnly" 
          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
        min="0" max="999"> 
    </div>
  </div>


  <div id="MRErrors"  :class="{'form-group row my-0 py-0': $v.numMaxClean.$error}"  v-show="$v.numMaxClean.$error">
    <div class="col-sm-4 my-0 py-0" v-if="!$v.numMaxClean.required">      
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3"  v-if="!$v.numMaxClean.required">Max Cleaning count is required.</p> 
    <div class="col-sm-4 my-0 py-0" v-if="!$v.numMaxClean.between">      
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3" v-if="!$v.numMaxClean.between">Max clean must be an integer between 0 and 999.</p> 
  </div>

  <div class="form-group row my-0 mt-1">
    <label class="col-sm-4 label-small my-0">Emergency Dental Coverage Programs:</label>
    <div class="col-sm-2 my-0">      
       <input id="EDC1" v-model="codeProgEDC1" placeholder="" 
          class="form-control form-control-xs" maxlength="3" :disabled="disableEDC||viewOnly" min="0" max="999"> 
    </div>
    <div class="col-sm-2 my-0">
       <input id="EDC2" v-model="codeProgEDC2" placeholder="" 
          class="form-control form-control-xs" maxlength="3" :disabled="disableEDC||viewOnly" min="0" max="999"> 
    </div>
    <div class="col-sm-2 my-0">
       <input id="EDC3" v-model="codeProgEDC3" placeholder="" 
          class="form-control form-control-xs" maxlength="3" :disabled="disableEDC||viewOnly" min="0" max="999"> 
    </div>
  </div>  
  <div class="form-group row my-0 mt-1">
      <div class="col-sm-4 label-small my-0">
      </div>
      <div class="col-sm-2">
        <label class="label-smaller-helper sml-gray">PHRS PGM1</label>
      </div>
      <div class="col-sm-2">
        <label class="label-smaller-helper">PHRS PGM2</label>
      </div>
      <div class="col-sm-2">
        <label class="label-smaller-helper">PHRS PGM3</label>
      </div>
  </div>
  <div class="form-group row my-0 mt-1">
      <label class="col-sm-4 label-small my-0"></label>
      <div class="col-sm-2 my-0">
          <input id="EDC4" v-model="codeProgEDC4" placeholder="" 
            class="form-control form-control-xs" maxlength="3" :disabled="disableEDC||viewOnly" min="0" max="999"> 
      </div>
      <div class="col-sm-2 my-0">
          <input id="EDC5" v-model="codeProgEDC5" placeholder="" 
            class="form-control form-control-xs" maxlength="3" :disabled="disableEDC||viewOnly" min="0" max="999"> 
      </div>
  </div>
  <div class="form-group row my-0 mt-1">
      <div class="col-sm-4 label-small my-0">
      </div>
      <div class="col-sm-2">
        <label class="label-smaller-helper sml-gray">PHRS PGM4</label>
      </div>
      <div class="col-sm-2">
        <label class="label-smaller-helper">PHRS PGM5</label>
      </div>
  </div>  
        <div class="row my-0">
        <div class="col-sm-4 label-small my-0">
        </div>        
        <div class="col-sm-6">
          <label class="label-smaller-helper sml-gray">Emergency Dental Coverage: 3 digits max per entry</label>
        </div>
      </div>      
  <!-- <div id="edcErrors1"  :class="{'form-group row my-0 py-0': $v.codeProgEDC1.$error}" v-show="$v.codeProgEDC1.$error">
    <div class="col-sm-4 my-0 py-0">      
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3"  v-if="!$v.codeProgEDC1.$numeric">
          EDC1 must be an integer between 0 and 999.</p> 
  </div> -->
  <div id="edcErrors"  :class="{'form-group row my-0 py-0': $v.codeProgEDC1.$error||$v.codeProgEDC2.$error||$v.codeProgEDC3.$error
        ||$v.codeProgEDC4.$error||$v.codeProgEDC5.$error}"  v-show="$v.codeProgEDC1.$error||$v.codeProgEDC2.$error||$v.codeProgEDC3.$error
        ||$v.codeProgEDC4.$error||$v.codeProgEDC5.$error">
    <div class="col-sm-4 my-0 py-0">      
    </div>
    <p class="col-sm-8 my-0 py-0 sml-red pl-3"  v-if="
        (!($v.codeProgEDC1.$numeric||!$v.codeProgEDC1.between))||
        (!($v.codeProgEDC2.$numeric||!$v.codeProgEDC2.between))||
        (!($v.codeProgEDC3.$numeric||!$v.codeProgEDC3.between))||
        (!($v.codeProgEDC4.$numeric||!$v.codeProgEDC4.between))||
        (!($v.codeProgEDC5.$numeric||!$v.codeProgEDC5.between))
        ">EDC entries must be blank, or an integer between 1 and 999.
        <br>
        {{edcError}} {{edcErrorEntries}}
    </p>        
  </div>
  <div v-if="viewOnly">
    <div class="form-group row my-0 mt-1">
      <label class="col-sm-4 label-small my-0">Created By:</label>
      <div class="col-sm-8 my-0"> {{ this.origSTS.createdby }} </div>
    </div> 
    <div class="form-group row my-0 mt-1">
      <label class="col-sm-4 label-small my-0">Created Date:</label>
      <div class="col-sm-8  my-0"> {{ this.createdDate }} </div>
    </div> 
    <div class="form-group row my-0 mt-1">
      <label class="col-sm-4 label-small my-0">Last Modified By:</label>
      <div class="col-sm-8 my-0"> {{ this.origSTS.lastmodifiedby }} </div>
    </div> 
    <div class="form-group row my-0 mt-1">
      <label class="col-sm-4 label-small my-0">Last Modified Date:</label>
      <div class="col-sm-8  my-0"> {{ this.lastmodifiedDate }} </div>
    </div> 
  </div>
</form>

<hr>
<div class="row">
    <div class="col-sm-6" v-if="!viewOnly">
        <button id="btnAddEdit" v-on:click="ServiceTypeAddEdit" type="button" :v-show="!viewOnly" class="btn BtnSave btn-sml"><i :class="saveIcon"></i>{{saveBtnName}}</button>
    </div>
    <div class="col-sm-6">
        <button id="btnExit" v-on:click="Exit" type="button" class="btn BtnClose btn-sml float-right"> <i class="fas fa-times"></i>  Close Form  </button>
    </div>
</div> 
</div>
</template>

<script> 
import axios from 'axios'
import Vue from 'vue'; 
import Vuelidate from 'vuelidate'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import {helpers, required, minLength,sameAs, not, maxLength, numeric, integer, between} from 'vuelidate/lib/validators'
import { notEqual } from 'assert';
import { isContext } from 'vm';
import { truncate } from 'fs';
import { debuglog } from 'util';

Vue.use(Vuelidate);
export default {
  props: {
    IsCopy: {type: Boolean, required: true},
    ServiceTypeData:{type: Object,
       required: true},  
    AllowEdit: {type:Boolean,
       required: true }, 
    action: {type: String, required: true},
  },
    
  data: function () {
    return {
            numMaxClean:1,
            saveIcon:'fas fa-plus',
            saveBtnName:'Add Service Type',
            stData: [],
            datapickClass:"form-control form-control-xs my-0",
            showUpdate:true,
            showOldPassword:true,
            activeColor: 'red',
            fontSize: 30,  
            selectService:[],
            selectSubType:[],
            services:[],
            sService: [],
            subTypes:[], //selected type
            sSubTypes: '', //selected sub types
            codeUnits: [],
            newSTS: '',
            origSTS: '',
            Datepicker: '', 
            exit: '',
            DateFormat: '',
            effectiveDate: '',
            expiryDate: '',
            numMaxBack: '',
            codeUnitMaxBack: '',
            numMaxGraphs: '',
            succeeded: false,
            Msg:'',
            showModal:false,
            ssize: 4,
            dbKey: '',
            serviceTypeID: '',
            createdBy: '',
            createdDate: '',
            lastmodifiedDate: '',
            IsNew: false,
            viewOnly: false,
            disableDescription: false,
            disableEffective: false,
            disableExpiry: false,
            disableMaxBack: false,
            disableMaxGraph: false,
            disableMaxClean: false,
            disableEDC: false,
            disableButtons: false,
            codeProgEDC1: '',
            codeProgEDC2: '',
            codeProgEDC3: '',
            codeProgEDC4: '',
            codeProgEDC5: '',
            edcError: 'There is invalid input in: ',
            edcError2: [],
          }
    },

    components: {
        Datepicker,
       // VSelect
    }, 

    methods: {
        Go(){
            this.$router.push('/DPEBB/SuperUser/ManageServiceType');
        },

        //pass in the "this" object for scoping
        SetControlsFromOriginal: function (vm)
        {
          vm.selectService = [];
          vm.selectSubType = [];
          vm.selectCUMaxBack = "";
          for (let index = 0; index < vm.services.length; index++) {
            const s = vm.services[index];
            if (vm.origSTS.serviceid == s.serviceid)
            {
              vm.selectService.push(s);
              vm.sService = s.serviceType;
            }
          }
          vm.newSTS.sservice = vm.sService;

          for (let index = 0; index < vm.subTypes.length; index++) {
            const s = vm.subTypes[index];
            if (vm.origSTS.subtypeid1 == s.subtypeid)
            {
              vm.selectSubType[0] = s
            }
            if (vm.origSTS.subtypeid2 == s.subtypeid)
            {
              vm.selectSubType[1] = s
            }
            if (vm.origSTS.subtypeid3 == s.subtypeid)
            {
              vm.selectSubType[2] = s
            }
            if (vm.origSTS.subtypeid4 == s.subtypeid)
            {
              vm.selectSubType[3] = s
            }
            if (vm.origSTS.subtypeid5 == s.subtypeid)
            {
              vm.selectSubType[4] = s
            }
            if (vm.origSTS.subtypeid6 == s.subtypeid)
            {
              vm.selectSubType[5] = s
            }
            if (vm.origSTS.subtypeid7 == s.subtypeid)
            {
              vm.selectSubType[6] = s
            }
            if (vm.origSTS.subtypeid8 == s.subtypeid)
            {
              vm.selectSubType[7] = s
            }
          }

          vm.sSubTypes = '';
          for (let i = 0; i < vm.selectSubType.length; i++) {
            if (vm.selectSubType[i] != undefined)
            {
              vm.sSubTypes += vm.selectSubType[i].code
            }
            else
            {
              vm.sSubTypes+= "   "
            }
          }
          vm.sSubTypes = vm.sSubTypes.padEnd(15, ' ');
          vm.newSTS.ssubtypes = vm.sSubTypes;

          for (let index = 0; index < vm.codeUnits.length; index++) {
            const element = vm.codeUnits[index];
            if (element.abbrv == vm.origSTS.codeunitmaxback)
            {
                vm.codeUnitMaxBack = element.abbrv;
            }            
          }
          vm.numMaxBack = vm.origSTS.nummaxback;
          vm.numMaxGraphs = vm.origSTS.nummaxgraphs;
          vm.numMaxClean = vm.origSTS.nummaxclean;
          if (vm.IsCopy)
          {
            vm.expiryDate = moment('9999/12/31', "YYYY-MM-DD").format('YYYY/MM/DD');
            vm.effectiveDate = moment(vm.origSTS.expirydate==undefined || 
                vm.origSTS.expirydate == moment('9999/12/31', "YYYY/MM/DD") ?
                moment(new Date(), "YYYY-MM-DD") : 
                moment(vm.origSTS.expirydate, "YYYY-MM-DD").add(1, 'day')).format('YYYY/MM/DD');
          }
          else
          {
            vm.effectiveDate = moment(vm.origSTS.effectivedate, "YYYY-MM-DD").format('YYYY/MM/DD');
            vm.expiryDate = moment(vm.origSTS.expirydate==undefined ?  
                moment('9999/12/31', "YYYY-MM-DD") : vm.origSTS.expirydate, "YYYY-MM-DD").format('YYYY/MM/DD');
          }

          //setup control disabling, only future dates can be adjusted.
          vm.disableDescription = true;
          if (vm.IsCopy)
          {
            //when copying all fields are available
            vm.disableEffective = true;
            vm.disableExpiry = false;
            vm.disableMaxBack = false;
            vm.disableMaxGraph = false;
            vm.disableMaxClean = false;
            vm.disableEDC = false;
          }
          else
          {
            if ((moment(vm.origSTS.effectivedate)).toISOString() > (moment().startOf('day')).toISOString())
            {
              //this is future dated, can change everythnig user configurable
              vm.disableEffective = true;
              vm.disableExpiry = false;
              vm.disableMaxBack = false;
              vm.disableMaxGraph = false;
              vm.disableMaxClean = false;
              vm.disableEDC = false;
            }
            else if ((moment(vm.origSTS.expirydate)).toISOString() >= (moment().startOf('day')).toISOString())
            {
              //this is current and the expiry is in the future, allow the user to change the expiry
              vm.disableEffective = true;
              vm.disableExpiry = false;
              vm.disableMaxBack = true;
              vm.disableMaxGraph = true;
              vm.disableMaxClean = true;
              vm.disableEDC = true;
            }
            else //this is all in the past, can't change anything
            {
              vm.disableEffective = true;
              vm.disableExpiry = true;
              vm.disableMaxBack = true;
              vm.disableMaxGraph = true;
              vm.disableMaxClean = true;
              vm.disableEDC = true;
            }
          }
        },


        ServiceTypeAddEdit: function (event) {  
          var vm = this;             
          vm.$v.$touch();
          if (!vm.$v.$invalid){   
            //double check EDC, sometimes when deleted they are not properly updating on the watch
            vm.newSTS.codeprogedc1 = vm.codeProgEDC1 == null || vm.codeProgEDC1 =="" ? '   ' : vm.codeProgEDC1.padStart(3, '0');
            vm.newSTS.codeprogedc2 = vm.codeProgEDC2 == null || vm.codeProgEDC2 =="" ? '   ' : vm.codeProgEDC2.padStart(3, '0');
            vm.newSTS.codeprogedc3 = vm.codeProgEDC3 == null || vm.codeProgEDC3 =="" ? '   ' : vm.codeProgEDC3.padStart(3, '0');
            vm.newSTS.codeprogedc4 = vm.codeProgEDC4 == null || vm.codeProgEDC4 =="" ? '   ' : vm.codeProgEDC4.padStart(3, '0');
            vm.newSTS.codeprogedc5 = vm.codeProgEDC5 == null || vm.codeProgEDC5 =="" ? '   ' : vm.codeProgEDC5.padStart(3, '0');
            var offset = (new Date()).getTimezoneOffset() / 60; 
            var effDate =  moment(vm.effectiveDate, "YYYY/MM/DD").startOf('day').subtract(offset, 'hours');
            var expDate = moment(vm.expiryDate, "YYYY/MM/DD").startOf('day').subtract(offset, 'hours');
            var url = "SaskHealthApi/Host/PostServiceTypeAddEdit";
            var params = {              
              "_": moment(),
              "DBKey": vm.newSTS.dbkey,
              "ServiceTypeID": vm.newSTS.servicetypeid,
              "ServiceID": vm.newSTS.serviceid,
              "Service": vm.newSTS.sservice,
              "Description": vm.newSTS.description,
              "EffectiveDate": effDate,
              "ExpiryDate": expDate,
              "SubTypeID1": vm.newSTS.subtypeid1,
              "SubTypeID2": vm.newSTS.subtypeid2,
              "SubTypeID3": vm.newSTS.subtypeid3,
              "SubTypeID4": vm.newSTS.subtypeid4,
              "SubTypeID5": vm.newSTS.subtypeid5,
              "SubTypeID6": vm.newSTS.subtypeid6,
              "SubTypeID7": vm.newSTS.subtypeid7,
              "SubTypeID8": vm.newSTS.subtypeid8,
              "SubTypes": vm.newSTS.ssubtypes,
              "CodeUnitMaxBack": vm.newSTS.codeunitmaxback,
              "NumMaxBack": vm.newSTS.nummaxback.padStart(3, '0'),
              "NumMaxGraphs": vm.newSTS.nummaxgraphs.padStart(3, '0'), 
               "NumMaxClean": vm.newSTS.nummaxclean.padStart(3, '0'), 
              "CodeProgEDC1": vm.newSTS.codeprogedc1 != null? vm.newSTS.codeprogedc1.padStart(3, '0'):"   ",
              "CodeProgEDC2": vm.newSTS.codeprogedc2 != null? vm.newSTS.codeprogedc2.padStart(3, '0'):"   ",
              "CodeProgEDC3": vm.newSTS.codeprogedc3 != null? vm.newSTS.codeprogedc3.padStart(3, '0'):"   ",
              "CodeProgEDC4": vm.newSTS.codeprogedc4 != null? vm.newSTS.codeprogedc4.padStart(3, '0'):"   ",
              "CodeProgEDC5": vm.newSTS.codeprogedc5 != null? vm.newSTS.codeprogedc5.padStart(3, '0'):"   ",
              "mode": (vm.IsNew? 'A': 'U')
              
            }             

            vm.disableButtons= true;

            axios({
                method: 'post',
                url: url,
                headers: { 'Authorization': 'Bearer ' + vm.$store.getters.GetAccessToken },
                data: params
            }).then(function (response) {
                response                              
                vm.succeeded = true;
                var newOrUpdate = vm.IsNew? "New" : "Update to";
                vm.Msg = newOrUpdate + " Service Type Standard " + vm.newSTS.description + " saved. ";
                vm.showModal=true;  
              }
            ).catch(function(er) {                        
                  vm.succeeded = false;
                  vm.Msg="Service Type Standard " +  vm.newSTS.description + " was not successfully saved:" + "( " + er.response.data.message + "). " ; 
                  vm.showModal=true; 
            })
            vm.disableButtons= false;

          }
        },

        Exit: function (event) {
          this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        }, 

        PopMsgClose(){
          this.showModal=false;
          if(this.succeeded)
          {
             this.$emit('finished');              
          } 
        }
    },

    //Get Service Type values and service sub type vales from the DB
    //We make sure we have all the code tables we need loaded before calling SetControlsFromDatabase
    mounted: function () {
       var vm = this;
       axios.all([
          axios.get('/SaskHealthApi/Codes/GetServices?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }}),
          axios.get('/SaskHealthApi/Codes/GetServiceSubTypes?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }}),
          axios.get('/SaskHealthApi/Codes/GetCodeUnits?_='+Date.now(), { headers: { 'Authorization': 'Bearer ' + localStorage.access_token }})
        ])
      .then(axios.spread(function(services, subTypes, codeUnits) {
          vm.services = services.data;
          vm.subTypes = subTypes.data;
          vm.codeUnits = codeUnits.data;
      }))
      .catch(function (er) {
      }).then(function () {
          vm.SetControlsFromOriginal(vm);
      })
      .catch(function (er) {
      })
    },

    created: function()
    {
      if(this.action =="EDIT")
      {
          this.saveIcon = 'far fa-edit';
          this.saveBtnName ='Edit Service Type';
      }
      this.DateFormat= this.$store.getters.GetDateFormat;
      this.viewOnly = !(this.AllowEdit);
      if (this.ServiceTypeData != null)
      {
        this.origSTS = this.ServiceTypeData;
        //copy everything then differentiate ID etc if this is a clone, make sure we capture the edc in the array
        this.codeProgEDC1 = this.origSTS.codeprogedc1.trim();
        this.codeProgEDC2 = this.origSTS.codeprogedc2.trim();
        this.codeProgEDC3 = this.origSTS.codeprogedc3.trim();
        this.codeProgEDC4 = this.origSTS.codeprogedc4.trim();
        this.codeProgEDC5 = this.origSTS.codeprogedc5.trim();
        this.newSTS = {
          "_": Date.now(),
          servicetypeid: this.origSTS.servicetypeid,
          subtypeid1: this.origSTS.subtypeid1,
          subtypeid2: this.origSTS.subtypeid2,
          subtypeid3: this.origSTS.subtypeid3,
          subtypeid4: this.origSTS.subtypeid4,
          subtypeid5: this.origSTS.subtypeid5,
          subtypeid6: this.origSTS.subtypeid6,
          subtypeid7: this.origSTS.subtypeid7,
          subtypeid8: this.origSTS.subtypeid8,
          description: this.origSTS.description,
          effectivedate: this.origSTS.effectivedate,
          expirydate: this.origSTS.expirydate,
          codeunitmaxback: this.origSTS.codeunitmaxback,
          nummaxback: this.origSTS.nummaxback,
          nummaxgraphs: this.origSTS.nummaxgraphs,
           nummaxclean: this.origSTS.nummaxclean,
          createdby: this.origSTS.createdby,
          createddate: this.origSTS.createddate,
          lastmodifiedby: this.origSTS.lastmodifiedby,
          lastmodifieddate: this.origSTS.lastmodifieddate,
          dbkey: this.origSTS.dbkey,
          serviceid: this.origSTS.serviceid,
          codeprogedc1: this.origSTS.codeprogedc1,
          codeprogedc2: this.origSTS.codeprogedc2,
          codeprogedc3: this.origSTS.codeprogedc3,
          codeprogedc4: this.origSTS.codeprogedc4,
          codeprogedc5: this.origSTS.codeprogedc5,
          ssubtypes: "",
          sservice: ""
        }
        if(this.IsCopy)
        {
          this.newSTS.servicetypeid = null
          this.newSTS.createdby = null;
          this.newSTS.createddate = null;
          this.newSTS.dbkey = null;
          this.IsNew = true;
        }
      this.createdDate = moment(this.origSTS.createddate, "YYYY-MM-DD").format('YYYY/MM/DD');  
      this.lastmodifiedDate = moment(this.origSTS.lastmodifieddate, "YYYY-MM-DD").format('YYYY/MM/DD'); 
      }
      else
      {
        alert("Unable to load Service Type Standard");
        this.Exit();
      }    
    }, 

    beforeCreate() {     

    },
    
    computed:
    { 
      //return the selected items int the multiselect boxes as comma seperated values
        subTypeList:function()
        {
          return this.selectSubType.map(selectSubType => selectSubType.subtype).join(', ');
        },

        serviceList:function()
        {
          return this.selectService.map(selectService => selectService.service).join(', ');
        },
        edcErrorEntries:function()
        {
           if (!this.codeProgEDC1 == "" & (!Number.isInteger(this.codeProgEDC1) || Number(this.codeProgEDC1) < 0 || Number(this.codeProgEDC1) > 999 ))
           {
             if(this.edcError2.indexOf("EDC1") < 0)
              this.edcError2.push("EDC1");
           }
           else
           { 
             if(this.edcError2.indexOf("EDC1") > -1)
              this.edcError2.splice( this.edcError2.indexOf("EDC1"), 1);
           }
           if (!this.codeProgEDC2 == "" & (!Number.isInteger(this.codeProgEDC2) || Number(this.codeProgEDC2) < 0 || Number(this.codeProgEDC2) > 999 ))
           {
             if(this.edcError2.indexOf("EDC2") < 0)
              this.edcError2.push("EDC2");
           }
           else
           { 
             if(this.edcError2.indexOf("EDC2") > -1)
              this.edcError2.splice( this.edcError2.indexOf("EDC2"), 1);
           }
           if (!this.codeProgEDC3 == "" & (!Number.isInteger(this.codeProgEDC3) || Number(this.codeProgEDC3) < 0 || Number(this.codeProgEDC3) > 999 ))
           {
             if(this.edcError2.indexOf("EDC3") < 0)
              this.edcError2.push("EDC3");
           }
           else
           { 
             if(this.edcError2.indexOf("EDC3") > -1)
              this.edcError2.splice( this.edcError2.indexOf("EDC3"), 1);
           }
           if (!this.codeProgEDC4 == "" & (!Number.isInteger(this.codeProgEDC4) || Number(this.codeProgEDC4) < 0 || Number(this.codeProgEDC4) > 999 ))
           {
             if(this.edcError2.indexOf("EDC4") < 0)
                this.edcError2.push("EDC4");
           }
           else
           { 
             if(this.edcError2.indexOf("EDC4") > -1)
              this.edcError2.splice( this.edcError2.indexOf("EDC4"), 1);
           }
           if (!this.codeProgEDC5 == "" & (!Number.isInteger(this.codeProgEDC5) || Number(this.codeProgEDC5) < 0 || Number(this.codeProgEDC5) > 999 ))
           {
             if(this.edcError2.indexOf("EDC5") < 0)
                this.edcError2.push("EDC5");
           }
           else
           { 
             if(this.edcError2.indexOf("EDC5") > -1)
              this.edcError2.splice( this.edcError2.indexOf("EDC5"), 1);
           }
          return this.edcError2.join(", ");
        }
    },

    watch:
    {
      codeUnitMaxBack: function(val) {
        this.newSTS.codeunitmaxback = val;
      },
      numMaxBack:  function(val) {
        this.newSTS.nummaxback = val;
      },
      numMaxGraphs: function(val){
        this.newSTS.nummaxgraphs = val;
      },
      numMaxClean: function(val){
        this.newSTS.nummaxclean = val;
      },
      codeProgEDC1: function(val){
           this.newSTS.codeprogedc1 = val == null ? '   ' : val.padStart(3, '0');
      },
      codeProgEDC2: function(val){
           this.newSTS.codeprogedc2 = val == null ? '   ' : val.padStart(3, '0');
      },
      codeProgEDC3: function(val){
           this.newSTS.codeprogedc3 = val == null ? '   ' : val.padStart(3, '0');
      },
      codeProgEDC4: function(val){
           this.newSTS.codeprogedc4 = val == null ? '   ' : val.padStart(3, '0');
      },
      codeProgEDC5: function(val){
           this.newSTS.codeprogedc5 = val == null ? '   ' : val.padStart(3, '0');
      },
      expiryDate: function(val){
          this.newSTS.expirydate = moment(val).startOf('day');
      },
      effectiveDate: function(val){
          this.newSTS.effectivedate = moment(val).startOf('day');
      }
    },

    validations(){
      return { 
        effectiveDate:{
            required
        },
        expiryDate:{
            required,
            minValue: value => (moment(this.expiryDate).toISOString()) >= (moment(this.effectiveDate).toISOString())
        },
        numMaxBack: {
          required,
          between: between(0, 365)
        },
        numMaxGraphs: {
          required,
          between: between(0, 999)
        },
        numMaxClean: {
          required,
          between: between(0, 999)
        },
        codeProgEDC1: {
          numeric,
          between: between(1, 999)
        },
        codeProgEDC2: {
          numeric,
          between: between(1, 999)
        },
        codeProgEDC3: {
          numeric,
          between: between(1, 999)
        },
        codeProgEDC4: {
          numeric,
          between: between(1, 999)
        },
        codeProgEDC5: {
          numeric,
          between: between(1, 999)
        }
      }
    }    
}
</script>

<style scopped>
.ddlList {
  font-size: 0.75em !important;
  color:slategray;
}

.calendarCss {
  width: 200px; 
  padding: 0 !important;
  margin: 0 !important;
  background: #f3fafe;
  }

.modal-header {    
    padding: .25rem !important;
    align-content: center;
    text-align: center !important;
}

.modal-footer
{
  padding: .75rem !important;
}

.form-group {
  margin-bottom: 0;
}

</style>
